// src/seo/AboutSEO.js
import { SEO_CONFIG } from './SEOConfig';

export const AboutSEOData = {
    title: "About Us | ഉയിർമൊഴിയെക്കുറിച്ച്",
    description: "Learn about Uyirmozhy Publications. Started in 2017 in Venjaramoodu, we are dedicated to publishing premium Malayalam books and promoting literary culture.",
    keywords: "Uyirmozhy history, Malayalam publishers Venjaramoodu, Rajasree Sajeev, Grameenan, Vinod Bhanuvikraman, book publishing Kerala",
    url: `${SEO_CONFIG.baseUrl}/about`,

    // The Schema Logic
    schema: {
        ...SEO_CONFIG.baseSchema,
        "url": `${SEO_CONFIG.baseUrl}/about`,
        "foundingDate": "2017",
        "description": "Uyirmozhy Publications: Established in 2017 in Venjaramoodu, promoting Malayalam literature.",
        "location": {
            "@type": "Place",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Venjaramoodu",
                "addressRegion": "Thiruvananthapuram",
                "addressCountry": "IN"
            }
        },
        "employee": [
            {
                "@type": "Person",
                "name": "Rajasree Sajeev",
                "jobTitle": "Chairman"
            },
            {
                "@type": "Person",
                "name": "Grameenan",
                "jobTitle": "Publisher / Managing Editor"
            },
            {
                "@type": "Person",
                "name": "Vinod Bhanuvikraman",
                "jobTitle": "Treasurer"
            }
        ]
    }
};